module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Reply-374ec81a6a8c7d9e32840a8c58cfc2a1.svg";